import { call, put } from "redux-saga/effects"

import api from "apis"
import { setOrderSubmitResults } from "areas/checkout/store/actions"
import { isTestMode } from "helpers/application"

export default function* doLogin(action) {
  let url = "/users/sign_in.json"
  console.log("SAGA LOGIN: ", action.values)
  try {
    const result = yield call(api.post, url, action.values)
    console.log("RESULT: ", result)
    if (result.success) {
      window.location.reload()
      if (!isTestMode) {
        dataLayer.push({
          event: "login",
        })
      }
    } else {
      yield put(setOrderSubmitResults(result))
    }
  } catch (e) {
    console.log("Error logging in user", e)
  }
  action.setSubmitting(false)
}
